interface CheckDnsAnswer {
  Status: number;
}

export const getCheckDns = async (domain: string): Promise<CheckDnsAnswer | null> => {
  const response = await fetch(`https://dns.google/resolve?name=${domain}`, {cache:"force-cache"});
  return response.json();
};
